import { TabList, TabPanel } from "@mui/lab"
import { Box, Tab, styled } from "@mui/material"

export const UMTabsWrapper = styled(Box)({
  "& .MuiTabPanel-root": {
    padding: "0px",
  },
})

export const StyledTabPanel = styled(TabPanel)({
  padding: "0"
})

export const StyledTabList = styled(TabList)({
  // border: "1px solid red",
  // marginLeft: "10px",
  // justifyContent: "space-between",
  // alignItems: "center",
  // width: "100%",
  height: "8vh",
  color: "#706F70",
  ".MuiTab-root": {
    color: "#706F70",
    textTransform: "capitalize",
    fontSize: "12px",
    fontFamily: "Poppins",
    padding: 0,
  },
  ".MuiTab-root.Mui-selected": {
    color: "#000000",
  },
  ".MuiTabs-indicator": {
    backgroundColor: "#3C77EF",
    // maxWidth: "34px",
    height: "4px",
  },
})

export const StyledTab = styled(Tab)({

})